<template>
    <!-- "MOTP-01-05-08-01": "휴대폰/이메일 변경 안내"-->
    <action-sheet
      :opened.sync="openedCpt"
      :action-header="true"
      :action-footer="true"
      :use-top-border="true"
      title="MOTP-01-05-08-01"
      class="action-sheet"
      @cancel="close"
    >
      <template #content>
        <!-- 본인 인증을 위해서는 영업점에서 등록한 개인정보만 사용 가능합니다. <br />휴대폰/이메일 정보는 아래의 방법으로 변경 할 수 있습니다. -->
        <p v-html="$t('MOTP-01-07-03-02')"></p>
        <ul class="ulist ulist-type--bullet">
          <li>{{$t('MOTP-01-07-03-03')}}</li>
        </ul>
      </template>
      <template #footer>
        <button
          class="btn bottom positive"
          @click="close"
        >{{ /*확인*/ $t("MOTP-01-07-03-05") }}</button>
      </template>
    </action-sheet>
</template>

<script>
export default {
    props: {
        opened : {
            type: Boolean,
            required: true,
            default : false
        }
    },
    computed: {
      openedCpt : {
        get() {
          return this.opened;
        },
        set(value) {
          this.$emit("update:opened", value);
        }
      }
    },
    methods: {
        close() {
            this.openedCpt = false
        }
    }
}
</script>